
import Vue from "vue";
import {
  getOrderImportList,
  getOrderImportDetail,
  updateOrderImport,
  deleteOrderImport,
  updateOrderPaymentStatus,
  getOrderAmount,
  getConferenceDetail,
  getPdf,
  submitPaper,
  getBaseUrl,
  updateContactInfo,
} from "@/utils/api";

export default Vue.extend({
  name: "order-management",
  data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      limit: 20,
      timer: null,
      multipleSelection: [],
      searchGroup: {
        code: "",
        conferenceCode: "",
        title: "",
        projectNumber: "",
        groupNumber: "",
        submitter: "",
        authors: "",
        progress: null as any,
        paymentStatus: null as any,
        contactInformationName: "",
        contactInformationEmail: "",
        contactInformationPhone: "",
        paymentAt: [],
      },
      loading: true,
      defaultTime: ["00:00:00", "23:59:59"],
      dialogVisible: false,
      dialogMode: "" as "view" | "edit" | "",
      currentId: null as any,
      canSave: false, // 控制Save按钮是否可用
      form: {
        code: "",
        title: "",
        authors: "",
        projectNumber: "",
        groupNumber: "",
        submitter: "",
        totalPages: null as any,
        basePages: null as any,
        basePublicationFee: null as any,
        discountAmount: null as any,
        orderAmount: null as any,
        contactInformationName: "",
        contactInformationEmail: "",
        contactInformationPhone: "",
        paymentUrl: "",
      } as any,
      contactInfoChanged: false,
      originalContactInfo: {},
      rules: {
        code: [{ required: true, message: "请输入 Code", trigger: "blur" }],
        title: [{ required: true, message: "请输入 Title", trigger: "blur" }],
        authors: [
          { required: true, message: "请输入 Authors", trigger: "blur" },
        ],
        projectNumber: [
          { required: true, message: "请输入 Project Number", trigger: "blur" },
        ],
        groupNumber: [
          { required: true, message: "请输入 Group Number", trigger: "blur" },
        ],
        submitter: [
          {
            required: true,
            message: "请输入 Deliver teacher",
            trigger: "blur",
          },
        ],
        totalPages: [
          { required: true, message: "请输入 Total Pages", trigger: "blur" },
        ],
        basePages: [
          { required: true, message: "请输入 Base Pages", trigger: "blur" },
        ],
        basePublicationFee: [
          {
            required: true,
            message: "请输入 Base Publication Fee",
            trigger: "blur",
          },
        ],
        discountAmount: [
          {
            required: true,
            message: "请输入 Discount Amount",
            trigger: "blur",
          },
        ],
        orderAmount: [
          { required: true, message: "请输入 Order Amount", trigger: "blur" },
        ],
        contactInformationName: [
          {
            required: true,
            message: "请输入 contactInformationName",
            trigger: "blur",
          },
        ],
        contactInformationEmail: [
          {
            required: true,
            message: "请输入 contactInformationEmail",
            trigger: "blur",
          },
        ],
        contactInformationPhone: [
          {
            required: true,
            message: "请输入 contactInformationPhone",
            trigger: "blur",
          },
        ],
        paymentUrl: [
          { required: true, message: "请输入 paymentUrl", trigger: "blur" },
        ],
      },
      // Review 弹框相关
      reviewDialogVisible: false,
      reviewForm: {
        paymentMethod: "Alipay",
        discountAmount: null as any,
        orderAmount: null as any,
        contactInformationName: "",
        contactInformationEmail: "",
        contactInformationPhone: "",
        paymentUrl: "",
        paymentAt: "",
      } as any,
      currentReviewId: null as any,
      // 证书的数据
      certificateData: {} as any,
      conferenceId: "",
      authors: "",
      code: "",
      title: "",
    };
  },
  watch: {
    "searchGroup.paymentAt"(val) {
      if (!val) {
        this.searchGroup.paymentAt = [];
      }
    },
  },
  created() {
    this.getTableData();
  },
  computed: {
    isEdit(): boolean {
      return this.dialogMode === "edit";
    },
    dialogTitle(): string {
      if (this.dialogMode === "view") return "View Order";
      if (this.dialogMode === "edit") return "Edit Order";
      return "Order";
    },
  },
  methods: {
    // 检测联系信息变化
    checkContactInfoChange() {
      const currentInfo = {
        contactInformationName: this.form.contactInformationName || "",
        contactInformationEmail: this.form.contactInformationEmail || "",
        contactInformationPhone: this.form.contactInformationPhone || "",
      };

      this.contactInfoChanged =
        currentInfo.contactInformationName !==
          (this.originalContactInfo as any).contactInformationName ||
        currentInfo.contactInformationEmail !==
          (this.originalContactInfo as any).contactInformationEmail ||
        currentInfo.contactInformationPhone !==
          (this.originalContactInfo as any).contactInformationPhone;
    },
    copyLink(row: any) {
      const orderId = row?.id;
      // 判断当前环境（正式环境使用固定域名，其他环境使用当前域名）
      const baseUrl = getBaseUrl();
      const url = `${baseUrl}/submission?conferenceId=${encodeURIComponent(
        row.conferenceId
      )}&orderId=${orderId}&status=student&from=b`;
      this.copyText(url)
        .then(() => {
          this.$message.success("链接已复制");
        })
        .catch(() => {
          this.$message.error("复制失败，请手动复制");
        });
    },
    async copyText(text: string) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }
      return new Promise<void>((resolve, reject) => {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          const successful = document.execCommand("copy");
          successful ? resolve() : reject();
        } catch (e) {
          reject(e as any);
        } finally {
          document.body.removeChild(textarea);
        }
      });
    },
    // 打开支付审核弹框
    openReviewDialog(row: any) {
      this.currentReviewId = row.id;
      this.reviewForm = {
        paymentMethod: row.paymentMethod || "Alipay",
        discountAmount: row.discountAmount,
        orderAmount: row.orderAmount,
        contactInformationName: row.contactInformationName,
        contactInformationEmail: row.contactInformationEmail,
        contactInformationPhone: row.contactInformationPhone,
        paymentUrl: row.paymentUrl || "",
        paymentAt: row.paymentAt,
      };
      this.conferenceId = row.conferenceId;
      this.authors = row.authors;
      this.code = row.code;
      this.title = row.title;
      this.reviewDialogVisible = true;
    },
    // 审核通过
    async approvePayment() {
      try {
        const obj = {
          paymentStatus: 3,
          contactInformationName: this.reviewForm.contactInformationName,
          contactInformationEmail: this.reviewForm.contactInformationEmail,
          contactInformationPhone: this.reviewForm.contactInformationPhone,
        };
        await updateOrderPaymentStatus(this.currentReviewId, obj);
        this.$message.success("审核通过");
        this.reviewDialogVisible = false;
        this.getCertificateData();
        // this.getTableData();
      } catch (e) {
        this.$message.error("操作失败");
      }
    },
    // 获取对应生成投递的证书数据
    async getCertificateData() {
      try {
        const res: any = await getConferenceDetail(this.conferenceId);
        this.certificateData = {
          name: res.name || "",
          venue: res.venue || "",
          date: res.date || res.date || "",
          abbreviation: res.abbreviation || "",
          overview: res.overview || "",
          publication: res.publication || "",
          indexation: res.indexation || "",
          stamp: res.stamp || "",
          logo: res.logo || "",
          authors: this.authors,
          code: this.code,
          title: this.title,
        } as any;
        // 开始生成证书
        this.$nextTick(() => {
          this.generateCertificate();
        });
      } catch (e) {
        this.$message.error("获取会议信息失败");
      }
    },
    // 生成证书
    async generateCertificate() {
      this.loading = true;
      // 获取dom
      const singleDom = document.getElementById(
        "sawCertificateGenerator"
      ) as HTMLFormElement;
      // 获取元素的 HTML 字符串
      const htmlStr = singleDom.outerHTML;
      const obj = {
        htmlStr: htmlStr,
        marginTop: 0,
        marginBottom: 0,
      };
      const res = await getPdf(obj);
      const acceptanceLetterUrl = (res as any).url;
      await submitPaper(this.currentReviewId, { acceptanceLetterUrl });
      this.getTableData();
      this.loading = false;
    },
    // 审核拒绝
    async rejectPayment() {
      try {
        await updateOrderPaymentStatus(this.currentReviewId, {
          paymentStatus: 4,
        });
        this.$message.success("审核拒绝");
        this.reviewDialogVisible = false;
        this.getTableData();
      } catch (e) {
        this.$message.error("操作失败");
      }
    },
    // 撤回审核
    async withdrawPayment() {
      try {
        await updateOrderPaymentStatus(this.currentReviewId, {
          paymentStatus: 5,
        });
        this.$message.success("撤回审核");
        this.reviewDialogVisible = false;
        this.getCertificateData();
      } catch (e) {
        this.$message.error("操作失败");
      }
    },
    openOrderDialog(id: any, mode: "view" | "edit") {
      this.dialogMode = mode;
      this.currentId = id;
      this.canSave = false; // 重置Save按钮状态
      this.contactInfoChanged = false;
      this.fetchDetail(id);
    },
    async fetchDetail(id: any) {
      this.loading = true;
      try {
        const res: any = await getOrderImportDetail(id);
        this.form = {
          code: res.code || "",
          title: res.title || "",
          authors: res.authors || "",
          projectNumber: res.projectNumber || "",
          groupNumber: res.groupNumber || "",
          submitter: res.submitter || "",
          totalPages: res.totalPages || 0,
          basePages: res.basePages || 0,
          basePublicationFee: res.basePublicationFee || 0,
          discountAmount: res.discountAmount || 0,
          orderAmount: res.orderAmount || 0,
          progress: res.progress,
          paymentStatus: res.paymentStatus,
          contactInformationName: res.contactInformationName || "",
          contactInformationEmail: res.contactInformationEmail || "",
          contactInformationPhone: res.contactInformationPhone || "",
          paymentUrl: res.paymentUrl || "",
        } as any;
        this.originalContactInfo = {
          contactInformationName: res.contactInformationName || "",
          contactInformationEmail: res.contactInformationEmail || "",
          contactInformationPhone: res.contactInformationPhone || "",
        };
        this.dialogVisible = true;
      } catch (e) {
        this.$message.error("获取详情失败");
      } finally {
        this.loading = false;
      }
    },
    // 计算订单金额 - 参考Submission页面的逻辑
    async calculateOrderAmount() {
      // 检查所有必需字段是否已填写
      if (
        !this.form.totalPages ||
        !this.form.basePages ||
        !this.form.basePublicationFee ||
        this.form.discountAmount === null
      ) {
        this.canSave = false;
        return;
      }

      try {
        const params = {
          totalPages: this.form.totalPages,
          basePages: this.form.basePages,
          basePublicationFee: this.form.basePublicationFee,
          discountAmount: this.form.discountAmount,
        };

        const res: any = await getOrderAmount(params);

        if (res.orderAmount) {
          this.form.orderAmount = res.orderAmount;
          this.canSave = true;
        } else {
          this.$message.error("计算订单金额失败");
          this.canSave = false;
        }
      } catch (e) {
        this.$message.error("计算订单金额失败");
        this.canSave = false;
      }
    },
    submitOrder() {
      (this.$refs.orderForm as any).validate(async (valid: boolean) => {
        if (!valid) return;

        // if (!this.canSave) {
        //   this.$message.warning('请先计算订单金额');
        //   return;
        // }

        this.loading = true;
        try {
          const obj = {
            code: this.form.code,
            title: this.form.title,
            authors: this.form.authors,
            projectNumber: this.form.projectNumber,
            groupNumber: this.form.groupNumber,
            submitter: this.form.submitter,
            totalPages: this.form.totalPages,
            basePages: this.form.basePages,
            basePublicationFee: this.form.basePublicationFee,
            discountAmount: this.form.discountAmount,
            orderAmount: this.form.orderAmount,
            contactInformationEmail: this.form.contactInformationEmail,
            contactInformationName: this.form.contactInformationName,
            contactInformationPhone: this.form.contactInformationPhone,
          };
          await updateOrderImport(this.currentId, obj);
          this.$message.success("保存成功");
          this.dialogVisible = false;
          this.getTableData();
        } catch (e) {
          this.$message.error("保存失败");
        } finally {
          this.loading = false;
        }
      });
    },
    getTableData() {
      const searchParams: any = JSON.parse(JSON.stringify(this.searchGroup));

      const obj: any = {
        page: this.page,
        limit: this.limit,
        ...searchParams,
        orderType: 1,
      };
      // 去掉空值
      for (const key in obj) {
        if (obj[key] === "" || obj[key] === null || obj[key].length === 0)
          delete obj[key];
      }

      getOrderImportList(obj)
        .then((res: any) => {
          res.rows.forEach((item: any) => {
            if (item.paymentAt) {
              item.paymentAt = this.formatDate(
                new Date(item.paymentAt),
                "yyyy-MM-dd HH:mm:ss"
              );
            }
          });
          this.tableData = res.rows;
          this.total = res.count;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    formatDate(date: any, formatStr = "yyyy-MM-dd HH:mm:ss") {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      // 如果是考试时间或报名截止时间，使用中文年月日格式
      if (formatStr === "yyyy/MM/dd") {
        return `${year}/${month}/${day}`;
      }

      return formatStr
        .replace("yyyy", year)
        .replace("MM", month)
        .replace("dd", day)
        .replace("HH", hours)
        .replace("mm", minutes)
        .replace("ss", seconds);
    },
    async deleteOrder(id: any) {
      deleteOrderImport(id)
        .then((res: any) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getTableData();
        })
        .catch((err: any) => {
          // console.log(err)
        });
    },

    onPageChange(page: number) {
      this.page = page;
      this.getTableData();
    },
    handleSizeChange(limit: number) {
      this.limit = limit;
      this.getTableData();
    },
    pageChange(page: number) {
      if (this.timer !== null) clearTimeout(this.timer as any);
      (this.timer as any) = setTimeout(() => {
        this.page = page;
        this.getTableData();
      }, 1000);
    },
    updateContactInfo() {
      updateContactInfo(this.currentId, {
        contactInformationName: this.form.contactInformationName,
        contactInformationEmail: this.form.contactInformationEmail,
        contactInformationPhone: this.form.contactInformationPhone,
      }).then((res: any) => {
        this.$message({
          type: "success",
          message: "修改成功!",
        });
        this.contactInfoChanged = false; // 重置修改状态
        this.dialogVisible = false;
        this.getTableData();
      });
    },
    getUrlBase() {
      const origin = location.hostname; // 当前访问域名
      let requestBase = "";
      if (process.env.NODE_ENV === "development") {
        requestBase = process.env.VUE_APP_BASE_CRM_API_PROXY as any;
      } else {
        if (origin.indexOf("-testserver") > -1) {
          // requestBase = process.env.VUE_APP_TEST_SEAVER_API;
          requestBase = "https://gec-api-testserver.gecacademy.cn/cicServer";
        } else {
          // requestBase = process.env.VUE_APP_SERVE_API;
          requestBase = "https://gec-api.gecacademy.cn/cicServer";
        }
      }
      return requestBase;
    },
    exportTable() {
      const urlBase = this.getUrlBase();
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      // // 修改点：创建深拷贝避免污染原始数据
      const data = JSON.parse(JSON.stringify(this.searchGroup));
      data.orderType = 1;

      const searchStr = Object.entries(data)
        .filter(
          ([key, value]) =>
            value !== null &&
            value !== undefined &&
            value !== "" &&
            !(Array.isArray(value) && value.length === 0)
        )
        .map(([key, value]) => {
          // 只针对 paymentAt 参数进行特殊处理
          if (Array.isArray(value)) {
            // 只针对 paymentAt 参数进行特殊处理
            if (key === "paymentAt") {
              const encodedValues = value.map((val) => encodeURIComponent(val));
              return `${key}=[${encodedValues.join(",")}]`;
            } else {
              // 其他数组参数保持原样
              return value
                .map((val) => `${key}=${encodeURIComponent(val)}`)
                .join("&");
            }
          }
          return `${key}=${encodeURIComponent(
            value as string | number | boolean
          )}`;
        })
        .join("&");
      const url =
        urlBase + "/export/order/page" + (searchStr ? `?${searchStr}` : "");
      // console.log(url);

      // 创建下载链接
      // const a = document.createElement('a');
      // a.href = url;
      // a.download = 'cic-订单列表.xlsx';
      // document.body.appendChild(a);
      // a.click();
      // document.body.removeChild(a);
      // loading.close();

      // 使用 fetch API 获取文件流
      fetch(url, {
        method: "GET",
        credentials: "include", // 包含 cookie
      })
        .then((response) => response.blob())
        .then((blob) => {
          // 创建 Blob URL 并下载
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = "cic-订单列表.xlsx"; // 此时这个设置会生效
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(blobUrl); // 释放内存
          loading.close();
        })
        .catch((error) => {
          console.error("下载失败:", error);
          loading.close();
        });
    },
  },
});
